import { API } from "../../http-Common"

class MessageBoard {
    getConversation(senderId, receiverId, pageIndex, pageSize) {
        return API.post("/GetConversation", null, { params: { senderId, receiverId, pageIndex, pageSize } })
    }
}
const messageBoard = new MessageBoard();
export default messageBoard;